import axios from "axios";
import httpClient from "./httpClient";

const getApiData = async (url, config = {}) => {
  try {
    return await httpClient.get(url, config);
  } catch (error) {
    // Aborts are expected when a newer search supersedes an in-flight one.
    if (
      axios.isCancel?.(error) ||
      error?.code === "ERR_CANCELED" ||
      error?.name === "CanceledError" ||
      error?.name === "AbortError"
    ) {
      throw error;
    }
    console.error("Error:", error);
    throw error;
  }
};

export default getApiData;
